import React from 'react';
import { SVGProps } from './type';

const Icon = ({ fill }: SVGProps) => (
  <g transform="translate(-3, -3) scale(0.85, 0.85)">
    <path
      d="M27 4.5H9C7.80653 4.5 6.66193 4.97411 5.81802 5.81802C4.97411 6.66193 4.5 7.80653 4.5 9V27C4.5 28.1935 4.97411 29.3381 5.81802 30.182C6.66193 31.0259 7.80653 31.5 9 31.5H27C28.1935 31.5 29.3381 31.0259 30.182 30.182C31.0259 29.3381 31.5 28.1935 31.5 27V9C31.5 7.80653 31.0259 6.66193 30.182 5.81802C29.3381 4.97411 28.1935 4.5 27 4.5ZM9 7.5H27C27.3978 7.5 27.7794 7.65804 28.0607 7.93934C28.342 8.22064 28.5 8.60218 28.5 9V21.54L23.7 17.445C22.9563 16.8331 22.0231 16.4985 21.06 16.4985C20.0969 16.4985 19.1637 16.8331 18.42 17.445L7.5 26.55V9C7.5 8.60218 7.65804 8.22064 7.93934 7.93934C8.22064 7.65804 8.60218 7.5 9 7.5ZM27 28.5H9.84L20.34 19.74C20.5417 19.5902 20.7863 19.5094 21.0375 19.5094C21.2887 19.5094 21.5333 19.5902 21.735 19.74L28.5 25.5V27C28.5 27.3978 28.342 27.7794 28.0607 28.0607C27.7794 28.342 27.3978 28.5 27 28.5Z"
      fill={fill}
    />
    <path
      d="M12 15C13.2426 15 14.25 13.9926 14.25 12.75C14.25 11.5074 13.2426 10.5 12 10.5C10.7574 10.5 9.75 11.5074 9.75 12.75C9.75 13.9926 10.7574 15 12 15Z"
      fill={fill}
    />
  </g>
);

export default Icon;
